import Paper from '@material-ui/core/Paper'
import React from 'react'
import { DragDropContainer, DropTarget } from 'react-drag-drop-container'
import * as ReactDOM from 'react-dom'
import { withStyles } from '@material-ui/core'
import Button from '@material-ui/core/Button'
import circle_of_hate_svg from '../../media/cycle_of_hate/Breaking_Cycles_of_Violence-Building_Resilience.svg'
import SVGInline from 'react-svg-inline'
import { scrollToTop } from './ArticlePointMapSegment'

export const CIRCLE_OF_HATE = 'CIRCLE_OF_HATE'

const styles = theme => ({
  pointsBackground: {
    margin: '0 auto',
    flex: 1
  },
  pyramidContainer: {
    // display: 'flex',
    maxWidth: 1260
  },
  pyramidImage: {
    // width: '50%',
    // maxWidth: 630,
    // minHeight: 1200,
    // minWidth: 480

  },
  pyramidSvgContainer: {
    // height: 170,
    maxHeight: '70vh',
  },
  pyramidChoices: {
    // width: '50%',
    // maxWidth: 630
  },
  sortableList: {},

  sortableItem: {
    margin: '10px',
    textAlign: 'justify',
    paddingLeft: 5,
    borderLeft: 'black solid',
    minHeight: 160
  },
  SortableItemHeader: {
    backgroundColor: '#F90000',
    color: 'white',
    // margin: 5,
    padding: 3,
    textTransform: 'uppercase'
  },
  // svg: {
  //   width: '100%',
  //   display: 'block',
  //   maxHeight: '70%',
  //   backgroundColor: '#EDEDED',
  // },
  polygon: {
    fill: theme.palette.common.white,
    // fill: 'grey',
    stroke: theme.palette.divider,
    strokeWidth: 1,
  },
  svgText: {
    backgroundColor: '#F90000',
    color: 'white'
  },
  pyramidHeader: {
    backgroundColor: '#F90000',
    color: 'white',
    display: 'block',
    position: 'relative',
    padding: 5,
    textAlign: 'center'
  },
  wordSoup: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    alignItems: 'flex-start',
    alignContent: 'flex-start',
    // width: '50%'
  },
  draggableText: {
    margin: 3
  },
  dropTarget: {
    // backgroundColor: 'green',
    position: 'relative',
  },
  dragButton: {
    color: 'white',
    margin: 3,
    width: 200,
    height: 100,
    backgroundColor: theme.palette.secondary.main,
  },
  pyramidButton: {
    margin: 3,
    fontSize: 10,
    backgroundColor: 'black',
    color: 'white',
  }

})

let circle_levels = [
  {
    text: 'Mourning, grieving',
    groupId: 'g12886',
    bounds: { x: 1, y: 1, width: 100, height: 100 }
  },
  {
    text: 'Naming and/or confronting fears; accepting loss',
    groupId: 'g12864'
  },
  {
    text: 'Memorializing',
    groupId: 'g12810'
  },
  {
    text: 'Reflecting on root causes;\n' +
      'acknowledging the other\'s story',
    groupId: 'g12794'
  },
  {
    text: 'Committing\n' +
      'to take risks',
    groupId: 'g12726'
  },
  {
    text: 'Practicing tolerance\n' +
      'and coexistence',
    groupId: 'g12694'
  },
  {
    text: 'Engaging\n' +
      'the offender\n' +
      '(or society)',
    groupId: 'g12650'
  },
  {
    text: 'Choosing\n' +
      'to forgive',
    groupId: 'g12609'
  },
  {
    text: 'Establishing justice;\n' +
      'acknowledging responsibility;\n' +
      'exploring restitution\n' +
      'and "creative justice"',
    groupId: 'g12390'
  },
  {
    text: 'Transforming conflict;\n' +
      'negotiating solutions;\n' +
      'constructing joint narratives\n' +
      'In',
    groupId: 'g12477'
  },
  {
    text: 'Integrating trauma\n' +
      'into new self and/or\n' +
      'group identity',
    groupId: 'g12542'
  },
  {
    text: 'Possibility of\n' +
      'reconciliation',
    groupId: 'g12580'
  },
]

// TODO move to utils
export function shuffleArray (array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]]
  }
}

const HIT_FUZZ_FACTOR = 30

class CircleOfHateSegment extends React.Component {
  state = {
    items: circle_levels,
    correct: false,
    itemsToDrag: [],
    itemContainers: []
  }

  constructor (props) {
    super(props)
    this.dragContainer = React.createRef()
  }

  componentDidMount () {
    setTimeout(() => scrollToTop(this), 500)
    let rect = ReactDOM.findDOMNode(this)
      .getBoundingClientRect()
    if (!this.boundingRect) {
      this.boundingRect = rect
      this.forceUpdate()
    } else {
      this.boundingRect = rect
    }
    this.resetDraggable()
  }

  resetDraggable () {
    let itemsToDrag
    let itemContainers = []
    itemsToDrag = circle_levels.slice()
    shuffleArray(itemsToDrag)
    this.setState({ itemsToDrag, itemContainers })

    for (let item of itemsToDrag) {
      document.getElementById(item.groupId).setAttribute('visibility', ' hidden')
      document.getElementById(item.groupId + '-marker').setAttribute('visibility', ' hidden')
    }
  }

  setMarkerState (show) {
    let itemsToDrag
    if (show) {
      itemsToDrag = this.state.itemsToDrag.slice()
      for (let item of itemsToDrag) {
        document.getElementById(item.groupId + '-marker').setAttribute('visibility', ' visible')
      }
    } else {
      itemsToDrag = circle_levels.slice()
      for (let item of itemsToDrag) {
        document.getElementById(item.groupId + '-marker').setAttribute('visibility', ' hidden')
      }
    }

  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    let rect = ReactDOM.findDOMNode(this)
      .getBoundingClientRect()
    this.boundingRect = rect
  }

  render () {
    let {
      classes,
      // ...props
    } = this.props
    let { itemsToDrag } = this.state

    return <Paper>
      <div className={classes.pyramidContainer}>
        <div className={classes.pyramidImage}>
          <div className={classes.pyramidSvgContainer}>
            <DropTarget targetKey={`target_1`}
                        onHit={({ dragData, dragElem, containerElem, ...otherProps }) => {
                          let rect = ReactDOM.findDOMNode(this.dragContainer.current)
                            .getBoundingClientRect()
                          let xS = otherProps.x - rect.left //x position within the element.
                          let yS = otherProps.y - rect.top  //y position within the element.

                          let whole_svg = document.getElementsByClassName('SVGInline-svg')[0]
                          let svgWS = whole_svg.width.baseVal.valueInSpecifiedUnits
                          let svgHS = whole_svg.height.baseVal.valueInSpecifiedUnits

                          let svgWSOrig = whole_svg.width.baseVal.value
                          let svgHSOrig = whole_svg.height.baseVal.value

                          let svgRealWidth = svgWSOrig / (svgHSOrig / rect.height)
                          xS -= (rect.width - svgRealWidth) / 2

                          let group = document.getElementById(dragData.groupId)
                          let groupBBox = group.getBBox()
                          // rescale the group coordinates to screen coordinates
                          let xScale = svgWSOrig / svgWS
                          let yScale = rect.height / svgHS
                          xScale = yScale

                          if (xS > groupBBox.x * xScale - HIT_FUZZ_FACTOR &&
                            xS < (groupBBox.x + groupBBox.width) * xScale + HIT_FUZZ_FACTOR &&
                            yS > groupBBox.y * yScale - HIT_FUZZ_FACTOR &&
                            yS < (groupBBox.y + groupBBox.height) * yScale + HIT_FUZZ_FACTOR
                          ) {
                            itemsToDrag.splice(
                              itemsToDrag.indexOf(dragData), 1
                            )
                            group.setAttribute(
                              'visibility', 'visible')
                            this.setState({ itemsToDrag })
                            this.setMarkerState(false)
                          }
                        }}
            >
              <SVGInline svg={circle_of_hate_svg} component={'div'} width={'100%'} height={'70vh'}
                         ref={this.dragContainer}
              />
            </DropTarget>
          </div>
        </div>

        <div>
          {/*<div> Drag the action to the correct level of the pyramid</div>*/}
          <div className={classes.wordSoup}>
            {itemsToDrag.map(item => (
                <DragDropContainer
                  targetKey={`target_1`} key={item.groupId}
                  className={classes.draggableText}
                  dragData={item}
                  onDragStart={() => {
                    this.setMarkerState(true)
                  }}
                  onDragEnd={() => this.setMarkerState(false)}
                  style={{ position: 'unset', flex: 1 }}
                >
                  <Button className={classes.dragButton}>{`${item.text}`}</Button>
                </DragDropContainer>
              )
            )
            }
          </div>
        </div>
      </div>

    </Paper>
  }
}

export default withStyles(styles)(CircleOfHateSegment)
